module.exports = __webpack_public_path__ + "static/img/1089_big.01e9d69.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1089_big.png
// module id = QZGb
// module chunks = 1